import axios from 'axios';

import { appConfig } from '../constants';

const getHeaders = (token) => {
  return {
    Authorization: `Bearer ${token}`
  };
};

export const post = ({ url, data, token, options }) => {
  return axios.post(`${appConfig.apiBaseUrl}${url}`, data, {
    ...(options || {}),
    headers: getHeaders(token)
  });
};

export const get = async ({ url, token, options }) => {
  const result = await axios.get(`${appConfig.apiBaseUrl}${url}`, {
    ...(options || {}),
    headers: getHeaders(token)
  });
  return result.data;
};

export const patch = async ({ url, data, token, options }) => {
  const result = await axios.patch(`${appConfig.apiBaseUrl}${url}`, data, {
    ...(options || {}),
    headers: getHeaders(token)
  });
  return result.data;
};

export const put = async ({ url, data, token, options }) => {
  const headers = {
    ...getHeaders(token),
    ...(data instanceof FormData ? {} : { 'Content-Type': 'application/json' })
  };

  return axios.put(`${appConfig.apiBaseUrl}${url}`, data, {
    ...(options || {}),
    headers
  });
};
